<script>
    export default {
        data() {
            return {
                media: window.ViewPort.media
            }
        },
        mounted() {
            EventBus.listen('window-resized', data => this.media = data.media);
        }
    }
</script>